import React, { Component } from 'react'
import { connect } from 'react-redux'

import * as R from 'ramda'
import moment from 'moment'

import TextField from 'material-ui/TextField'
import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card'
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import DatePicker from 'material-ui/DatePicker'

import ValidTextField from 'components/validTextField'

import dataActions from 'actions/dataActions'

import { doc, dirtyRead } from 'selectors/common'
import Section from 'components/Section'
import { getTimezoneDate } from 'utils/date'
import {getMonth} from 'utils/date'

let select = dirtyRead(
	(state, props) => ({
		property: doc(state, props.propertyID)
	})
)

export class Price extends Component{
	render(){
		let { props } = this
		let propertyID = props.propertyID
		return(
			<Section id="property/price" title="Price">
				<div style={{width: "auto", marginTop: "-20px"}}>

					<ValidTextField
						value={props.property.priceDwellings}
						key={'props.property.priceDwellings'+props.property.priceDwellings}
						symbol="$"
						style={{
							width: "48%",
							marginBottom: "-15px",
							float: "left"
						}}
						floatingLabelText = "Dwellings"
						onBlur={(value) =>{
							props.STAGE({
								_id: propertyID
								, priceDwellings: +value
							})
						}}
					/>
					<ValidTextField
						value={props.property.priceLand}
						key={'props.property.priceLand'+props.property.priceDwellings}
						symbol="$"
						style={{
							width: "48%",
							marginBottom: "-15px",
							float: "right"
						}}
						floatingLabelText = "Land"
						onBlur={(value) =>{
							props.STAGE({
								_id: propertyID
								, priceLand: +value
							})
						}}
					/>
				<div style={{clear: "both", paddingBottom:"20px"}}> </div>
				</div>
			</Section>
		)
	}
}

export default connect(select, dataActions)(Price)



// WEBPACK FOOTER //
// ./src/routes/landlord/propertyForm/Price.js